import ProductsService from "@/services/ProductsService";

import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

export const getProducts = createAsyncThunk(
  "products",
  async (params, {rejectWithValue}) => {
    try {
      const response = await ProductsService.getProducts(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const getAllProducts = createAsyncThunk(
  "all/products",
  async (_, {rejectWithValue}) => {
    try {
      const response = await ProductsService.getAllProducts();

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  data: [],
  sort: {value: "created_at", direction: "desc"},
  search: "",
  page: 1,
  size: 5,
  totalData: null,
  totalPages: null,
  inactiveData: false,
  selectedData: null,
  errors: null,
  error: "",
  status: "",
};

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    setData(state, action) {
      state.data = action.payload;
    },
    setSelectedData(state, action) {
      state.selectedData = action.payload;
    },
    setSearch(state, action) {
      state.search = action.payload;
      state.page = 1;
    },
    setPage(state, action) {
      state.page = Math.max(1, action.payload);
    },
    setSize(state, action) {
      state.size = action.payload;
    },
    setSort(state, action) {
      state.sort = action.payload;
    },
    setTotalPages(state, action) {
      state.totalPages = action.payload;
    },
    setTotalData(state, action) {
      state.totalData = action.payload;
    },
    decrementTotalData(state) {
      state.totalData -= 1;
    },
    setInactiveData(state, action) {
      state.inactiveData = action.payload;
    },
    clearTable() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state) => {
        pendingState(state);
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.totalData = action.payload.total
          ? action.payload.total
          : state.totalData;
        state.totalPages = action.payload.total
          ? Math.ceil(action.payload.total / state.size)
          : state.totalPages;
        fulfilledState(state);
      })
      .addCase(getProducts.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(getAllProducts.pending, (state) => {
        pendingState(state);
      })
      .addCase(getAllProducts.fulfilled, (state, action) => {
        state.data = action.payload;
        fulfilledState(state);
      })
      .addCase(getAllProducts.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {
  setPage,
  setSort,
  clearTable,
  setTotalPages,
  setErrors,
  setError,
  setSize,
  setStatus,
  setSelectedData,
  setData,
  setSearch,
  setTotalData,
  decrementTotalData,
  setInactiveData,
} = productsSlice.actions;
export default productsSlice.reducer;
